module.exports = __webpack_public_path__ + "img/58ne.109947bc.svg";